import { UpcomingComplianceItem } from '../../../types/ComplianceReminder/ComplianceReminderType'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../utils/apiUtils'
import { AllowedHttpMethods, complianceReminderApiConfig } from '../apiList'

const getUpcomingComplianceDueDates = async (): Promise<
  UpcomingComplianceItem[]
> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: complianceReminderApiConfig.getUpcomingComplianceDueDates,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const upComingComplianceApi = {
  getUpcomingComplianceDueDates,
}

export default upComingComplianceApi
